/* PlayShop — recherche : un ET entre les mots, au lieu du OU de Shopify.
 *
 * ⛔ LE PROBLEME, mesure le 21/09/2026 : le formulaire envoyait `q` brut, et Shopify traite alors
 * les mots en OU. « mezastar » rendait 1 002 resultats, « poussacha » 27, et « mezastar poussacha »
 * 1 000 : la recherche a deux mots etait donc PLUS large que chacun des deux.
 *
 * ⛔ Ce qui ne marche pas, teste un par un : le mot AND en clair (pris pour un terme), les
 * asterisques, le prefixe +, options[prefix], type=product. Et la phrase exacte entre guillemets
 * rend bien 5 resultats mais DEPEND DE L ORDRE : « poussacha mezastar » rend 0. Un client tape
 * dans le desordre, c est donc inutilisable.
 *
 * ✅ Ce qui marche : la syntaxe par CHAMP, avec un ET entre les termes.
 *      (title:m1 OR tag:m1 OR body:m1) AND (title:m2 OR tag:m2 OR body:m2)
 *    mezastar poussacha 1 000 -> 6   |   coffret dracaufeu 429 -> 16
 *    display etincelles    23 -> 5   |   booster japonais       -> 8
 *
 * ⛔ Ne PAS se limiter a title: : « japonais » n est dans aucun titre (0 resultat) mais dans 123
 * descriptions. Les trois champs sont necessaires.
 */
(function () {
  'use strict';

  // Les champs interroges pour chaque mot. L'ordre n'a pas d'importance, c'est un OU.
  var CHAMPS = ['title', 'tag', 'body'];

  // ⛔ Ces caracteres ont un sens dans la syntaxe de recherche Shopify. Un mot qui en contient
  // doit etre cite, sinon la requete part en morceaux (« re-ment » lu comme une exclusion).
  function citer(mot) {
    return /["():\-*]/.test(mot) ? '"' + mot.replace(/"/g, '') + '"' : mot;
  }

  /**
   * Transforme une saisie en requete Shopify.
   * Un seul mot : on rend la saisie TELLE QUELLE. Le comportement actuel est deja bon
   * (« dracaufeu » rend 251 resultats pertinents) et la syntaxe par champ le retrecirait a tort.
   */
  function requeteEt(saisie) {
    var brut = String(saisie || '').trim();
    if (!brut) return '';
    var mots = brut.split(/\s+/).filter(function (m) { return m.length > 0; });
    if (mots.length < 2) return brut;
    return mots.map(function (m) {
      var c = citer(m);
      return '(' + CHAMPS.map(function (ch) { return ch + ':' + c; }).join(' OR ') + ')';
    }).join(' AND ');
  }

  /**
   * L'URL de la page de resultats. `qs` garde la SAISIE d'origine : sans elle, le champ de
   * recherche et le « X resultats pour ... » afficheraient la formule, illisible.
   */
  function urlRecherche(saisie) {
    var brut = String(saisie || '').trim();
    var q = requeteStricte(brut);
    var u = '/search?q=' + encodeURIComponent(q);
    if (q !== brut) u += '&qs=' + encodeURIComponent(brut);
    return u + suffixeFiltres();
  }

  // ── Requete STRICTE (17/10/2026) ─────────────────────────────────────────────────────────
  // Lorenzo : « pikachu » rendait Lokhlass, Piafabec, Pop Luffy... « pas tres coherent ».
  // Mesure : 1 048 produits dont 766 (73 %) sans Pikachu ni dans le titre ni dans un tag.
  // Deux causes : (1) la description des cartes cite la carte PRECEDENTE et SUIVANTE de
  // l extension (« la carte precedente, 028/131 - Pikachu EX »), (2) la recherche Shopify
  // brute rapproche aussi des produits ou le mot n est NULLE PART (Piafabec, Pokebox Nidoking).
  // ⛔ options[fields] est IGNORE par la page /search (teste : 1 002 -> 1 002). Ce qui marche,
  // c est la syntaxe par champ SANS body : title, tag, product_type, vendor.
  // Si la requete stricte ne rend AUCUN produit (mot partiel pendant la frappe, nom d extension
  // qui n est que dans les descriptions), on retombe sur la requete LARGE d avant.
  var CHAMPS_STRICTS = ['title', 'tag', 'product_type', 'vendor'];
  // ⛔ PREFIXE (17/10/2026, Lorenzo : « Luffytaro c est Luffy ») : Shopify ne sait pas chercher
  // par prefixe dans un champ (title:luffy* = title:luffy, teste). L edge function recherche-corriger
  // rend les mots REELS du catalogue qui commencent par chaque mot tape (table recherche_vocabulaire,
  // fonction SQL recherche_prefixes, qui exclut les AUTRES Pokemon : Mewtwo n est pas Mew) ; on les
  // ajoute en OU, dans le titre et les tags seulement.
  function normaliser(m) {
    try { return String(m).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }
    catch (_) { return String(m).toLowerCase(); }
  }
  function requeteStricte(saisie, prefixes) {
    var brut = String(saisie || '').trim();
    if (!brut) return '';
    var mots = brut.split(/\s+/).filter(function (m) { return m.length > 0; });
    return mots.map(function (m) {
      var c = citer(m);
      var termes = CHAMPS_STRICTS.map(function (ch) { return ch + ':' + c; });
      var ext = (prefixes && prefixes[normaliser(m)]) || [];
      for (var i = 0; i < ext.length && i < 6; i++) {
        var e = citer(String(ext[i]));
        termes.push('title:' + e, 'tag:' + e);
      }
      return '(' + termes.join(' OR ') + ')';
    }).join(' AND ');
  }

  // ⛔ psRequeteEt reste la requete LARGE : la fenetre de suggestions du header s en sert pendant
  // la frappe, et seule la requete brute sait completer un mot partiel (« pika »).
  window.psRequeteEt = requeteEt;
  window.psRequeteStricte = requeteStricte;
  window.psUrlRecherche = urlRecherche;

  // ── Filtre « En stock seulement » et tri (contribution client du 06/10/2026) ──────────────
  // Filtre NATIF Shopify : filter.v.availability=1 (mesure le 16/10/2026 : « pikachu » 1 002
  // resultats -> 82) et sort_by (relevance, price-ascending, price-descending). L'etat vit dans
  // l'URL, et il est reporte sur CHAQUE URL de recherche que ce module fabrique : la recherche
  // vivante, les pages suivantes (Shopify les garde dans data-ps-next-url) et la soumission.
  var TRIS = { 'relevance': 1, 'price-ascending': 1, 'price-descending': 1 };
  var filtres = { dispo: false, tri: '' };
  try {
    var p0 = new URLSearchParams(location.search);
    filtres.dispo = p0.get('filter.v.availability') === '1';
    var t0 = p0.get('sort_by') || '';
    filtres.tri = TRIS[t0] && t0 !== 'relevance' ? t0 : '';
  } catch (_) {}

  function suffixeFiltres() {
    var u = '';
    if (filtres.dispo) u += '&filter.v.availability=1';
    if (filtres.tri) u += '&sort_by=' + encodeURIComponent(filtres.tri);
    return u;
  }

  // Les controles sont rendus par Shopify dans la zone, qui est remplacee a chaque frappe :
  // on leur remet l'etat courant apres chaque peinture.
  function synchroniserFiltres(racine) {
    var r = racine || document;
    var cases = r.querySelectorAll('[data-ps-filtre-dispo]');
    for (var i = 0; i < cases.length; i++) {
      cases[i].checked = filtres.dispo;
      cases[i].setAttribute('aria-checked', filtres.dispo ? 'true' : 'false');
    }
    // Le tri est un groupe de pastilles (radios) depuis le 17/10/2026 : on coche la bonne.
    var actif = filtres.tri || 'relevance';
    var tris = r.querySelectorAll('[data-ps-filtre-tri]');
    for (var j = 0; j < tris.length; j++) {
      if (tris[j].type === 'radio') tris[j].checked = (tris[j].value === actif);
      else tris[j].value = actif;
    }
  }

  // Relance la recherche vivante si elle est montee, sinon recharge la page avec la saisie.
  var relancerRecherche = null;
  function appliquerFiltres() {
    if (relancerRecherche) { relancerRecherche(); return; }
    try {
      var p = new URLSearchParams(location.search);
      p.delete('filter.v.availability');
      p.delete('sort_by');
      p.delete('page');
      var base = '/search?' + p.toString();
      window.location.href = base + suffixeFiltres();
    } catch (_) {}
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-ps-filtre-dispo]')) {
      filtres.dispo = !!t.checked;
      t.setAttribute('aria-checked', filtres.dispo ? 'true' : 'false');
    } else if (t.matches('[data-ps-filtre-tri]')) {
      if (t.type === 'radio' && !t.checked) return;
      var v = String(t.value || '');
      filtres.tri = TRIS[v] && v !== 'relevance' ? v : '';
    } else {
      return;
    }
    appliquerFiltres();
  });

  // ── Affichage de la page de resultats ────────────────────────────────────────────────────
  // ⛔ Liquid Shopify n'expose PAS les parametres d'URL : impossible de lire `qs` cote gabarit.
  // C'est donc ici qu'on remet la saisie d'origine, sinon la page affiche la formule et le
  // client ne peut ni la relire ni la corriger.
  function remettreLaSaisie() {
    synchroniserFiltres();
    var qs = null;
    try { qs = new URLSearchParams(location.search).get('qs'); } catch (_) { return; }
    if (!qs) return;
    var champ = document.querySelector('[data-ps-search-champ]');
    if (champ) champ.value = qs;
    // ⛔ querySelectorAll, pas querySelector : la page a DEUX etats, « X resultats pour... » et
    // « Aucun resultat pour... », et un seul des deux est rendu. Cibler le premier trouve
    // marchait tant que j'avais des resultats sous les yeux, et laissait la formule autrement.
    var termes = document.querySelectorAll('[data-ps-search-terme]');
    for (var i = 0; i < termes.length; i++) termes[i].textContent = qs;

    // ⛔ Si on a corrige la saisie, il faut le DIRE. Sinon le client lit des resultats qui ne
    // correspondent pas a ce qu'il a tape et croit que la recherche delire.
    var qc = null;
    try { qc = new URLSearchParams(location.search).get('qc'); } catch (_) {}
    if (qc && qc !== qs && termes.length) {
      var note = document.createElement('span');
      note.className = 'ps-search__correction';
      note.style.cssText = 'display:block;margin-top:6px;font-size:.9rem;font-weight:500;opacity:.75';
      note.textContent = 'Recherche effectuée pour « ' + qc + ' »';
      var hote = termes[0].closest('p, h2, div') || termes[0].parentNode;
      if (hote && !hote.querySelector('.ps-search__correction')) hote.appendChild(note);
    }
    // Le <title> vient de Shopify et contient lui aussi la formule : il s'affiche dans l'onglet,
    // dans l'historique et dans les favoris.
    try {
      if (document.title.indexOf('title:') >= 0) {
        document.title = document.title.replace(/«[^»]*»/, '« ' + qs + ' »');
      }
    } catch (_) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', remettreLaSaisie);
  } else {
    remettreLaSaisie();
  }

  // ── Correction des fautes de frappe ──────────────────────────────────────────────────────
  // Lorenzo : « une barre de recherche qui comprend ce qu'on lui ecrit meme avec des fautes ;
  // c'est le principe de la recherche, on n'a pas forcement l'intitule parfait ».
  // Shopify ne sait pas faire ca. Notre base, si : l'edge function recherche-corriger rapproche
  // chaque mot du vocabulaire REEL du catalogue (pg_trgm pour filtrer, levenshtein pour decider).
  var API_CORRECTION = 'https://ipvzpgwgujamtzztxvcu.supabase.co/functions/v1/recherche-corriger';
  var DELAI_MAX = 700; // ⛔ au-dela, on part sans correction : mieux vaut chercher que patienter

  // Rend { corrigee, prefixes }. En cas de lenteur ou d erreur : la saisie telle quelle, sans prefixe.
  function infosRecherche(saisie) {
    return new Promise(function (resolve) {
      var fini = false;
      var termine = function (v) { if (!fini) { fini = true; resolve(v); } };
      setTimeout(function () { termine({ corrigee: saisie, prefixes: {} }); }, DELAI_MAX);
      try {
        fetch(API_CORRECTION + '?q=' + encodeURIComponent(saisie))
          .then(function (r) { return r.json(); })
          .then(function (d) { termine({ corrigee: (d && d.corrigee) || saisie, prefixes: (d && d.prefixes) || {} }); })
          .catch(function () { termine({ corrigee: saisie, prefixes: {} }); });
      } catch (_) { termine({ corrigee: saisie, prefixes: {} }); }
    });
  }
  function corriger(saisie) {
    return infosRecherche(saisie).then(function (d) { return d.corrigee; });
  }

  // ── Resultats en direct, pendant la frappe ───────────────────────────────────────────────
  // ⛔ Pas une liste de suggestions au-dessus : c'est la GRILLE DE RESULTATS elle-meme qui se
  // rafraichit. On demande la vraie page de recherche et on en extrait la zone, donc la mise
  // en forme des cartes produit n'est dupliquee nulle part : c'est celle de Shopify.
  //
  // Trois pieges traites :
  //   1. une frappe = une requete : on attend 350 ms de silence ;
  //   2. les reponses n'arrivent pas dans l'ordre demande : on ignore celles qui ne
  //      correspondent plus a ce qui est tape, sinon l'affichage revient en arriere ;
  //   3. la correction orthographique coute un aller-retour de plus : on ne la demande QUE
  //      si la recherche brute ne rend rien.
  var DELAI_FRAPPE = 350;
  var MIN_CARACTERES = 2;

  function zoneResultats() { return document.querySelector('[data-ps-search-zone]'); }

  function styleChargement() {
    if (document.getElementById('ps-recherche-style')) return;
    var st = document.createElement('style');
    st.id = 'ps-recherche-style';
    st.textContent = '[data-ps-search-zone].is-chargement{opacity:.45;transition:opacity .15s}';
    document.head.appendChild(st);
  }

  function monterRechercheVivante() {
    var champ = document.querySelector('[data-ps-search-champ]');
    var zone = zoneResultats();
    if (!champ || !zone) return;
    styleChargement();

    var minuteur = null;
    var derniereSaisie = String(champ.value || '').trim();

    function peindre(html, saisie, corrigee, requeteUtilisee) {
      if (saisie !== derniereSaisie) return; // reponse perimee
      var z = zoneResultats();
      if (!z) return;
      z.innerHTML = html;
      z.classList.remove('is-chargement');
      synchroniserFiltres(z);
      // Les libelles viennent de la page distante : ils portent la formule, on remet la saisie.
      var termes = z.querySelectorAll('[data-ps-search-terme]');
      for (var i = 0; i < termes.length; i++) termes[i].textContent = saisie;
      if (corrigee && corrigee !== saisie) {
        var note = document.createElement('span');
        note.className = 'ps-search__correction';
        note.style.cssText = 'display:block;margin-top:6px;font-size:.9rem;font-weight:500;opacity:.75';
        note.textContent = 'Recherche effectuée pour « ' + corrigee + ' »';
        var hote = termes.length ? (termes[0].closest('p, h2, div') || termes[0].parentNode) : null;
        if (hote && !hote.querySelector('.ps-search__correction')) hote.appendChild(note);
      }
      // Les 50 premiers resultats sont la : on va chercher la suite immediatement.
      chargerLaSuite(saisie);
      // L'URL suit, pour que la page reste partageable et que le retour arriere fonctionne.
      try {
        var u = '/search?q=' + encodeURIComponent(requeteUtilisee || requeteStricte(corrigee || saisie)) + '&qs=' + encodeURIComponent(saisie);
        if (corrigee && corrigee !== saisie) u += '&qc=' + encodeURIComponent(corrigee);
        history.replaceState(null, '', u + '&qx=1' + suffixeFiltres());
      } catch (_) {}
    }

    // ⛔ Shopify ne rend que 50 resultats par page. On deroule les pages suivantes et on
    // ajoute leurs cartes a la grille, jusqu'a ce qu'il n'y ait plus de « suivante ».
    // La borne de 20 pages (1 000 produits) est un garde-fou : une recherche trop large ne doit
    // pas lancer une centaine de requetes dans le dos du client.
    var MAX_PAGES = 20;

    function chargerLaSuite(saisie) {
      var grille = document.querySelector('[data-ps-collection-grid][data-ps-next-url]');
      if (!grille) return;
      var suivante = grille.getAttribute('data-ps-next-url');
      var pages = 0;

      function etape() {
        if (!suivante || pages >= MAX_PAGES) return;
        if (saisie !== derniereSaisie) return; // l'utilisateur a retape : on laisse tomber
        pages++;
        fetch(suivante, { headers: { 'X-Requested-With': 'fetch' } })
          .then(function (r) { return r.text(); })
          .then(function (txt) {
            if (saisie !== derniereSaisie) return;
            var doc = new DOMParser().parseFromString(txt, 'text/html');
            var g2 = doc.querySelector('[data-ps-collection-grid]');
            var cible = document.querySelector('[data-ps-collection-grid]');
            if (!g2 || !cible) { suivante = null; return; }
            var items = g2.querySelectorAll('.ps-cl__item');
            for (var i = 0; i < items.length; i++) cible.appendChild(items[i]);
            suivante = g2.getAttribute('data-ps-next-url') || null;
            etape();
          })
          .catch(function () { suivante = null; });
      }
      etape();
    }

    // Rend le HTML de la zone de resultats pour une requete donnee, ou null si rien.
    function demander(requete) {
      var u = '/search?q=' + encodeURIComponent(requete) + suffixeFiltres();
      return fetch(u, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          var doc = new DOMParser().parseFromString(txt, 'text/html');
          var z = doc.querySelector('[data-ps-search-zone]');
          return z ? z.innerHTML : null;
        })
        .catch(function () { return null; });
    }

    function aDesProduits(html) {
      return !!html && html.indexOf('ps-cl__item') >= 0;
    }

    // Stricte d abord ; rien -> large ; toujours rien -> correction orthographique, et on rejoue.
    function essayer(saisie, terme, corrigee, prefixes) {
      var qStricte = requeteStricte(terme, prefixes);
      return demander(qStricte).then(function (html) {
        if (aDesProduits(html)) { peindre(html, saisie, corrigee, qStricte); return true; }
        var qLarge = requeteEt(terme);
        return demander(qLarge).then(function (h2) {
          if (aDesProduits(h2)) { peindre(h2, saisie, corrigee, qLarge); return true; }
          return h2 || html || '';
        });
      });
    }

    function chercher(saisie) {
      var z = zoneResultats();
      if (z) z.classList.add('is-chargement');
      // Un seul appel a l edge function : prefixes pour la saisie, et correction gardee de cote.
      infosRecherche(saisie).then(function (inf) {
        if (saisie !== derniereSaisie) return;
        var prefixes = inf.prefixes || {};
        essayer(saisie, saisie, null, prefixes).then(function (r) {
          if (r === true) return;
          var vide = r;
          // Rien trouve : c'est peut-etre une faute, et la correction est deja la.
          var corrigee = inf.corrigee;
          if (!corrigee || corrigee === saisie || corrigee === normaliser(saisie)) {
            peindre(vide, saisie, null, requeteStricte(saisie, prefixes)); return;
          }
          essayer(saisie, corrigee, corrigee, prefixes).then(function (r2) {
            if (r2 !== true) peindre(r2 || vide, saisie, corrigee, requeteStricte(corrigee, prefixes));
          });
        });
      });
    }

    relancerRecherche = function () {
      var saisie = String(champ.value || '').trim();
      if (saisie.length < MIN_CARACTERES) { relancerRecherche = null; appliquerFiltres(); return; }
      derniereSaisie = saisie;
      if (minuteur) clearTimeout(minuteur);
      chercher(saisie);
    };

    try {
      var pz = new URLSearchParams(location.search);
      var qz = pz.get('q') || '';
      var sz = String(champ.value || '').trim();
      if (qz.indexOf('product_type:') >= 0 && sz.length >= MIN_CARACTERES) {
        if (!aDesProduits(zone.innerHTML)) { derniereSaisie = sz; chercher(sz); }
        else if (!pz.get('qx')) {
          // Des resultats, mais sans les prefixes : on ne rejoue QUE s il y en a a ajouter.
          infosRecherche(sz).then(function (inf) {
            var p = inf.prefixes || {};
            for (var k in p) { if (p[k] && p[k].length) { derniereSaisie = sz; chercher(sz); return; } }
          });
        }
      }
    } catch (_) {}

    champ.addEventListener('input', function () {
      var saisie = String(champ.value || '').trim();
      derniereSaisie = saisie;
      if (minuteur) clearTimeout(minuteur);
      if (saisie.length < MIN_CARACTERES) return;
      minuteur = setTimeout(function () { chercher(saisie); }, DELAI_FRAPPE);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', monterRechercheVivante);
  } else {
    monterRechercheVivante();
  }

  // ── Collections populaires, les VRAIES ───────────────────────────────────────────────────
  // Lorenzo : « j'aimerais bien avoir les vraies collections populaires, pas un truc tout
  // moche comme ca, inutile ». Le bloc listait six accessoires ecrits en dur (Sleeves,
  // Classeurs, TopLoaders...) alors que les clients viennent pour du scelle : le vrai top est
  // mene par les Coffrets Dresseur d'Elite, les Displays One Piece et les Coffrets Pokemon.
  var API_COLLECTIONS = 'https://ipvzpgwgujamtzztxvcu.supabase.co/functions/v1/collections-populaires';

  // Le style des tuiles, calque sur les sous-categories du hub : une image qui porte, un
  // libelle sobre dessous. Pose une seule fois, et seulement si le bloc existe.
  function styleTuiles() {
    if (document.getElementById('ps-poptuiles-style')) return;
    var st = document.createElement('style');
    st.id = 'ps-poptuiles-style';
    st.textContent = [
      '.ps-poptuiles{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:14px}',
      '.ps-poptuile{display:flex;flex-direction:column;align-items:center;gap:10px;padding:16px 12px;',
      'border:1px solid rgba(255,255,255,.10);border-radius:16px;background:var(--ps-bg-elevated,#15171e);',
      'text-decoration:none;color:inherit;transition:border-color .15s,transform .15s}',
      '.ps-poptuile:hover{border-color:var(--ps-primary,#1A22DD);transform:translateY(-2px)}',
      '.ps-poptuile__media{display:grid;place-items:center;width:100%;height:96px}',
      '.ps-poptuile__media img{max-width:100%;max-height:96px;object-fit:contain;',
      'filter:drop-shadow(0 6px 14px rgba(0,0,0,.45))}',
      '.ps-poptuile__vide{width:64px;height:64px;border-radius:12px;background:rgba(255,255,255,.06)}',
      '.ps-poptuile__titre{font-weight:700;font-size:.92rem;text-align:center;line-height:1.25}'
    ].join('');
    document.head.appendChild(st);
  }
  function monterCollectionsPopulaires() {
    var grille = document.querySelector('[data-ps-collections-populaires]');
    if (!grille) return;
    // ⛔ Le « v » est un numero de version de l'APPEL, pas un cache-buster aleatoire : la reponse
    // reste mise en cache (10 min), mais changer ce numero apres une evolution de la fonction
    // evite de lire une ancienne reponse. Sans lui, j'ai cru une heure durant que les images ne
    // remontaient pas, alors qu'elles etaient deja dans la reponse fraiche.
    fetch(API_COLLECTIONS + '?n=6&v=2')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var cols = (d && d.collections) || [];
        // ⛔ Rien a afficher : on NE TOUCHE PAS au bloc. Le repli ecrit en dur reste visible.
        if (!cols.length) return;
        styleTuiles();
        grille.classList.add('ps-poptuiles');
        grille.innerHTML = cols.map(function (c) {
          // ⛔ Le titre vient de Shopify et peut contenir un tiret cadratin (62 collections en
          // portent un). Banni a l'affichage, en attendant que Lorenzo tranche sur les titres.
          var titre = String(c.titre || '').replace(/[<>]/g, '').replace(/\s*[—–]\s*/g, ' - ');
          var media = c.image
            ? '<img src="' + c.image + '&width=240" alt="" loading="lazy" draggable="false" oncontextmenu="return false;">'
            : '<span class="ps-poptuile__vide" aria-hidden="true"></span>';
          return '<a href="' + c.url + '" class="ps-poptuile">'
            + '<span class="ps-poptuile__media">' + media + '</span>'
            + '<span class="ps-poptuile__titre">' + titre + '</span></a>';
        }).join('');
      })
      .catch(function () { /* silence : le repli reste en place */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', monterCollectionsPopulaires);
  } else {
    monterCollectionsPopulaires();
  }

  // ── Interception des formulaires ─────────────────────────────────────────────────────────
  // Tous les formulaires qui pointent vers /search, d'ou qu'ils viennent : page de recherche,
  // barre du header, bloc de recherche.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') < 0) return;
    // ⛔ Le formulaire des filtres porte q = la FORMULE (search.terms) : le laisser passer par la
    // correction le casserait. Il se soumet par Entree sur le select : on applique, c est tout.
    if (form.hasAttribute('data-ps-search-filtres')) { e.preventDefault(); appliquerFiltres(); return; }

    var champ = form.querySelector('input[name="q"]');
    if (!champ) return;
    var saisie = String(champ.value || '').trim();
    if (!saisie) return;

    // ⛔ On prend la main sur la soumission : la correction est un aller-retour reseau, le
    // formulaire ne peut pas partir avant d'avoir sa reponse.
    e.preventDefault();

    infosRecherche(saisie).then(function (inf) {
      var corrigee = inf.corrigee;
      var q = requeteStricte(corrigee, inf.prefixes);
      var u = '/search?q=' + encodeURIComponent(q) + '&qx=1';
      // qs = ce que le client a TAPE, pour le reafficher tel quel.
      u += '&qs=' + encodeURIComponent(saisie);
      // qc = ce qui a REELLEMENT ete cherche, quand ce n'est pas la meme chose. La page le dit,
      // sinon le client croit que son orthographe etait bonne et ne comprend pas les resultats.
      if (corrigee && corrigee !== saisie) u += '&qc=' + encodeURIComponent(corrigee);
      window.location.href = u + suffixeFiltres();
    });
  }, true);
})();
